import React, { useEffect, useContext } from "react";
// import MigrationLogic from "../Migration/migrationlogic";
import { useNavigate } from "react-router-dom";
import { endpoints } from "../../services/endpoints";
import { axiosInstance } from "../../services/axiosInstance";
import { LinearProgress, Typography, Box, Grid } from "@mui/material";
import GenesysLogo from "../../assets/Genesyslogo.png";
import ConnectLogo from "../../assets/connect.png";
import GuideForm from "../GuidePopUp/guidePopUp";
import "./admin.css"
import {
  awsDetailsContext,
  genesysDetailsContext,
} from "../../context";
import {
  removeLSpaceFromString,
  removeRSpacefromString,
} from "../../preDefinedFunctions/removeLRSpacesString";
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";
import DotsLoader from "../DotsLoader/dotsLoader";
import CryptoJS from "crypto-js";

const Migration = () => {
  const genesysDetails = React.useContext(genesysDetailsContext);
  const awsDetails = React.useContext(awsDetailsContext);
  const [loading, setLoading] = React.useState(true);
const [pageErrorMessage, setPageErrorMessage] =React.useState("");
  const navigate = useNavigate();

  const [statusMap, setStatusMap] = React.useState({
  //  migrateUsersRolesQueues: "yetToStart",
    createQueues: "yetToStart",
    createSecurityProfiles: "yetToStart",
    createRoutingProfiles: "yetToStart",
    createUsers: "yetToStart",
    // uploadCustomerProfiles: "yetToStart",
    createCustProf: "yetToStart",
    // uploadQueueMetrics: "yetToStart",
    UIQueueMetrics: "yetToStart",
    // uploadAgentMetrics: "yetToStart",
    UIAgentMetrics: "yetToStart",
    // uploadSentimentAnalysisMetrics: "yetToStart",
    UISentimentAnalysisMetrics: "yetToStart",
  // uploadCallRecordingsMetrics: "yetToStart",
    UICallRecordingMetrics: "yetToStart"
  });
 const encryptPassword = (password) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(password));
  };

 const firstRun = React.useRef(true);

React.useEffect(() => {
  if (firstRun.current) {
    firstRun.current = false;
    return; // skip the first extra invocation
  }
    console.log("Checking if all required details are available:", {
      clientId: encryptPassword(genesysDetails?.clientId),
      clientSecret: encryptPassword(genesysDetails?.clientSecret),
      instanceId: encryptPassword(awsDetails?.instanceId),
      awsRegion: awsDetails?.awsRegion,
    });
    if (
      genesysDetails?.clientId &&
      genesysDetails?.clientSecret &&
      awsDetails?.instanceId &&
      awsDetails?.awsRegion
    ) {
      // handleClientCredentials()
      StoringGenesysConnectConfig()
      
      // handleCustomerRole();
    }
  }, [genesysDetails, awsDetails]);




const handleTriggerGenesysMigrationFunction = () => {
  const payload = {
    aws_account: awsDetails?.awsAccountNumber || "",
    aws_region: awsDetails?.awsRegion || "",
    client_id: encryptPassword(genesysDetails?.clientId || ""),
    client_secret: encryptPassword(genesysDetails?.clientSecret || ""),
    domain_name: awsDetails?.domainName || "",
    gen_region: genesysDetails?.genesysRegion || "",
    instance_id: encryptPassword(awsDetails?.instanceId || ""),
    organization_name: genesysDetails?.organizationName || "",
    role_arn: awsDetails?.roleArn || "",
  };

  axiosInstance
    .post(endpoints.genesysDetails.startMigration, payload)
    .then((response) => {
      const { statusCode, body } = response.data;
      if (statusCode === 200) {
        const parsedBody = typeof body === "string" ? JSON.parse(body) : body;
        const { taskId } = parsedBody;
        pollStepFunctionProgress(taskId);   // 👈 just listen
      } else {
        setPageErrorMessage("Migration failed to start.");
      }
    })
    .catch((error) => {
      console.error("Start migration error:", error);
      setPageErrorMessage("Migration failed to start.");
    });
};




const pollStepFunctionProgress = (taskId) => {
  console.log("Polling progress for TaskId:", taskId);

  const intervalId = setInterval(() => {
    axiosInstance
      .get(`${endpoints.genesysDetails.getProcess}/${taskId}`)
      .then((response) => {
        // ✅ read progress from API
        if(response.data.error === "true"){
          setPageErrorMessage(
          "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
        );
        }else {
        const steps = response.data.steps || [];
        const progress = steps[0]?.progress ?? 0;

        console.log("Progress:", progress);

        // --- Your status map updates ---
        if (progress < 25) {
          setStatusMap((prev) => ({ ...prev, createQueues: "inProgress" }));
        }
        else if (progress >= 25) {
          setStatusMap((prev) => ({ ...prev, createQueues: "migrated" }));
          setStatusMap((prev) => ({ ...prev, createSecurityProfiles: "inProgress" }));
        }
        else if (progress >= 30) {
          setStatusMap((prev) => ({ ...prev, createSecurityProfiles: "migrated" }));
          setStatusMap((prev) => ({ ...prev, createRoutingProfiles: "inProgress" }));
        }
        if (progress >= 35) {
          setStatusMap((prev) => ({ ...prev, createRoutingProfiles: "migrated" }));
          setStatusMap((prev) => ({ ...prev, createUsers: "inProgress" }));
        }
        if (progress >= 40) {
          setStatusMap((prev) => ({ ...prev, createUsers: "migrated" }));
          setStatusMap((prev) => ({ ...prev, createCustProf: "inProgress" }));
        }
        if (progress >= 45) {
          setStatusMap((prev) => ({ ...prev, createCustProf: "inProgress" }));
        }
        if (progress >= 50) {
          setStatusMap((prev) => ({ ...prev, createCustProf: "migrated" }));
        }

        if (progress >= 55) {
          setStatusMap((prev) => ({ ...prev, UIQueueMetrics: "inProgress" }));
        }
        if (progress >= 60) {
          setStatusMap((prev) => ({ ...prev, UIQueueMetrics: "migrated" }));
          setStatusMap((prev) => ({ ...prev, UIAgentMetrics: "inProgress" }));
        }
        if (progress >= 65) {
          setStatusMap((prev) => ({ ...prev, UIQueueMetrics: "migrated" }));
          setStatusMap((prev) => ({ ...prev, UIAgentMetrics: "inProgress" }));
        }
        if (progress >= 70) {
          setStatusMap((prev) => ({ ...prev, UIAgentMetrics: "migrated" }));
          setStatusMap((prev) => ({ ...prev, UISentimentAnalysisMetrics: "inProgress" }));
        }
        if (progress >= 75) {
          setStatusMap((prev) => ({ ...prev, UISentimentAnalysisMetrics: "inProgress" }));
        }
        if (progress >= 80) {
          setStatusMap((prev) => ({ ...prev, UISentimentAnalysisMetrics: "migrated" }));
        }

        if (progress >= 85) {
          setStatusMap((prev) => ({ ...prev, UICallRecordingMetrics: "inProgress" }));
        }
        if (progress >= 90) {
          setStatusMap((prev) => ({ ...prev, UICallRecordingMetrics: "inProgress" }));
          UIQueueMetrics();
        }

      }  
      })
      .catch((err) => {
        console.error("StepFunction progress error:", err);
        clearInterval(intervalId);
        setPageErrorMessage("Error checking migration progress. Try again.");
      });
  }, 20000); // poll every 20 seconds
};



  const StoringGenesysConnectConfig = () => {
    const payload = {
      organization_name: genesysDetails.organizationName,
      aws_region: awsDetails.awsRegion,
      gen_region: genesysDetails.genesysRegion,
      client_id: encryptPassword(genesysDetails.clientId),
      client_secret: encryptPassword(genesysDetails.clientSecret),
      aws_account: awsDetails.awsAccountNumber,
      aws_region: awsDetails.awsRegion,
      instance_id: encryptPassword(awsDetails.instanceId),
      role_arn: awsDetails.roleArn,
      domain_name: awsDetails.domainName
    };
    console.log("Sending request with payload:", payload);
    axiosInstance
      .post(endpoints.genesysDetails.GenesysConnectConfig, payload)
      .then((response) => {
        console.log("StoringGenesysConnectConfig1", response);
        if (response.data.statusCode === 200){
          handleTriggerGenesysMigrationFunction();
          //  setStatusMap(prev => ({ ...prev, migrateUsersRolesQueues: "inProgress" }));
        //  setStatusMap(prev => ({ ...prev, createQueues: "inProgress" }));
        // migrateUsersRolesQueues();
         } else {
        // Any other status → show error
        setPageErrorMessage(
          "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
        );
      }
    })
      .catch((error) => {
        console.error("handleClientCredentials Error", error);
        setPageErrorMessage(
        "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
      );
      });
  };




  const UIQueueMetrics = () => {
    const payload = {
      // aws_account: awsDetails.awsAccountNumber,
      //  client_id: genesysDetails.clientId,
      //  client_secret: genesysDetails.clientSecret,
      //  gen_region: genesysDetails.genesysRegion,
      // instance_id: awsDetails.instanceId,
      //  role_arn: awsDetails.roleArn,
      //  domain_name:awsDetails.domainName
      // aws_region: awsDetails.awsRegion,
    };
    console.log("Sending request with payload:", payload);
    axiosInstance
      .post(endpoints.genesysDetails.UiQueueMetrics, payload)
      .then((response) => {
        console.log("UIQueueMetrics", response);
        if (response.data.statusCode === 200) {
          localStorage.setItem("UIQueueMetricsResponse", JSON.stringify(response.data));
          console.log("Stored data uimetrix:", response.data);
          setStatusMap(prev => ({ ...prev, UIQueueMetrics: "migrated" }));
          setStatusMap(prev => ({ ...prev, UIAgentMetrics: "inProgress" }));
          // setStatusMap(prev => ({ ...prev, uploadAgentMetrics: "inProgress" }));
          // navigate('/Select-Metrics')
          // uploadAgentMetrics();
          UIAgentMetrics();
          
        }else {
        // Any other status → show error
        setPageErrorMessage(
          "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
        );
      }
    })
      .catch((error) => {
        console.error("UIQueueMetrics Error", error);
        setPageErrorMessage(
        "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
      );
      });
  };




  const UIAgentMetrics = () => {
    const payload = {
      // aws_account: awsDetails.awsAccountNumber,
      client_id: encryptPassword(genesysDetails.clientId),
      client_secret: encryptPassword(genesysDetails.clientSecret),
      instance_id: encryptPassword(awsDetails.instanceId),
      gen_region: genesysDetails.genesysRegion,
      // instance_id: awsDetails.instanceId,
      //  role_arn: awsDetails.roleArn,
      //  domain_name:awsDetails.domainName
      // aws_region: awsDetails.awsRegion,
    };
    console.log("Sending request with payload:", payload);
    axiosInstance
      .post(endpoints.genesysDetails.UiAgentMetrics, payload)
      .then((response) => {
        console.log("UIAgentMetrics", response);
        if (response.data.statusCode === 200) {
          localStorage.setItem("UIAgentMetricsResponse", JSON.stringify(response.data));
          console.log("Stored data uiAgentmetrix:", response.data);
          setStatusMap(prev => ({ ...prev, UIAgentMetrics: "migrated" }));
          // setStatusMap(prev => ({ ...prev, uploadSentimentAnalysisMetrics: "inProgress" }));
          setStatusMap(prev => ({ ...prev, UISentimentAnalysisMetrics: "inProgress" }));
          // UploadSentimentAnalysisMetrics();
          UISentimentAnalysisMetrics();
        }else {
        // Any other status → show error
        setPageErrorMessage(
          "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
        );
      }
    })
      .catch((error) => {
        console.error("UIAgentMetrics Error", error);
        setPageErrorMessage(
        "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
      );
      });
  };

  const UISentimentAnalysisMetrics = () => {
    const payload = {
      // aws_account: awsDetails.awsAccountNumber,
      //  client_id: genesysDetails.clientId,
      //  client_secret: genesysDetails.clientSecret,
      //  gen_region: genesysDetails.genesysRegion,
      // instance_id: awsDetails.instanceId,
      //  role_arn: awsDetails.roleArn,
      //  domain_name:awsDetails.domainName
      // aws_region: awsDetails.awsRegion,
    };
    console.log("Sending request with payload:", payload);
    axiosInstance
      .post(endpoints.genesysDetails.UiSentimentAnalysisMetrics, payload)
      .then((response) => {
        console.log("UISentimentAnalysisMetrics", response);
        if (response.data.statusCode === 200) {
          localStorage.setItem("UISentimentAnalysisMetrics", JSON.stringify(response.data));
          console.log("Stored data uisentimentmetrix:", response.data);
          setStatusMap(prev => ({ ...prev, UISentimentAnalysisMetrics: "migrated" }));
          // setStatusMap(prev => ({ ...prev, uploadCallRecordingsMetrics: "inProgress" }));
          setStatusMap(prev => ({ ...prev, UICallRecordingMetrics: "inProgress" }));
          // navigate('/Select-Metrics')
          // uploadCallRecordingsMetrics();
          UICallRecordingMetrics();
        }else {
        // Any other status → show error
        setPageErrorMessage(
          "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
        );
      }
    })
      .catch((error) => {
        console.error("UIQueueMetrics Error", error);
        setPageErrorMessage(
        "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
      );
      });
  };





  const UICallRecordingMetrics = () => {
    const payload = {
      // aws_account: awsDetails.awsAccountNumber,
      //  client_id: genesysDetails.clientId,
      //  client_secret: genesysDetails.clientSecret,
      //  gen_region: genesysDetails.genesysRegion,
      // instance_id: awsDetails.instanceId,
      //  role_arn: awsDetails.roleArn,
      //  domain_name:awsDetails.domainName
      // aws_region: awsDetails.awsRegion,
    };
    console.log("Sending request with payload:", payload);
    axiosInstance
      .post(endpoints.genesysDetails.UiCallRecordingsMetrics, payload)
      .then((response) => {
        console.log("UiCallRecordingsMetrics", response);
        if (response.data.statusCode === 200) {

          const body = typeof response.data.body === "string"
            ? JSON.parse(response.data.body)
            : response.data.body;

          localStorage.setItem("UiCallRecordingRecords", JSON.stringify(body));
          console.log("Parsed Interactions:", body.interactions);


          setStatusMap(prev => ({ ...prev, UICallRecordingMetrics: "migrated" }));
          // setStatusMap(prev => ({ ...prev, UICallRecordingMetrics: "inProgress" }));
          // uploadCallRecordingsMetrics();
          setLoading(false);
          navigate('/Select-Metrics');
        }else {
        // Any other status → show error
        setPageErrorMessage(
          "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
        );
      }
    })
      .catch((error) => {
        console.error("UiCallRecordingsMetrics Error", error);
        setPageErrorMessage(
        "There seems to be a technical problem. For assistance, please email support@lightgoldenrodyellow-hare-546075.hostingersite.com."
      );
      });
  };




  const statusLabels = {
    // migrateUsersRolesQueues: "Migrating Users, Roles, Queues",
    createQueues: "Queues",
    createSecurityProfiles: "Security Profiles",
    createRoutingProfiles: "Routing Profiles",
    createUsers: "Users",
    // uploadCustomerProfiles: "Uploading Customer Profiles",
    createCustProf: "Customer Profile",
    // uploadQueueMetrics: "Migrating Queue Metrics",
    UIQueueMetrics: "Queue Metrics",
    // uploadAgentMetrics: "Migrating Agent Metrics",
    UIAgentMetrics: "Agent Metrics",
    // uploadSentimentAnalysisMetrics: "Migrating Sentiment Metrics",
    UISentimentAnalysisMetrics: "Sentiment Metrics",
    // uploadCallRecordingsMetrics: "Migrating Call Recording Metrics",
    UICallRecordingMetrics: "Call Recording Metrics"
  };

    const visibleStatusKeys = Object.keys(statusLabels);
  const totalTasks = Object.keys(statusMap).length;
  const migratedCount = Object.values(statusMap).filter(
    (status) => status === "migrated"
  ).length;
  const progress = (migratedCount / totalTasks) * 100;

  useEffect(() => {
    if (
      genesysDetails?.clientId &&
      genesysDetails?.clientSecret &&
      awsDetails?.instanceId &&
      awsDetails?.awsRegion
    ) {
      StoringGenesysConnectConfig()
    }
  }, [genesysDetails, awsDetails]);
  const groupByStatus = (statusType) =>
    Object.entries(statusMap)
      .filter(([key, status]) => status === statusType && visibleStatusKeys.includes(key))
      .map(([key]) => statusLabels[key] || key);


  const columnStyle = {
    flex: 1,
    maxHeight: "300px",
    overflowY: "auto",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#fff",
  };

  const columnHeaderStyle = {
    marginTop: "1px",
    fontSize: "18px",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "Center",
    backgroundColor: "#1970b2",
    padding: "4px",
    color: "white",
    borderRadius: "5px",

  };

  const listStyle = {
    // listStyleType: "disc",
    paddingLeft: "20px",
    margin: 0,
    fontSize: "14px",
  };

  return (
    <MainTheme>
      <Title
        title={
          <span className="Loader-dots">
            Migration Progress
            {loading && <DotsLoader />}
          </span>
        }
      />

      <div className="organization-details-section">
        <Grid container spacing={2} className="container-section">
          <Grid item xs={12}>
            {pageErrorMessage && (
  <div style={{ marginTop: "20px", textAlign: "center", width: "100%" }}>
    <Typography className="error-text">{pageErrorMessage}</Typography>
  </div>
)}
            <Box sx={{ width: "90%", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "20px", }}>
              <img src={GenesysLogo} alt="Genesys Logo" style={{ width: 30, height: 30, marginRight: 18 }} />
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{ flexGrow: 0.9, width: 200, height: 4, borderRadius: 2 }}  // ← Thinner line
              />
              <img src={ConnectLogo} alt="End" style={{ width: 40, height: 35, marginLeft: 13 }} />
            </Box>


            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  // gap: "20px",
                  width: "100%",
                  maxWidth: "1200px",
                  // padding: "20px",
                  borderRadius: "10px",
                  // backgroundColor: "#f9f9f9",
                  // boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                  gap: "20px",
                }}
              >
                {/* Yet to Start Column
                <div style={columnStyle}>
                  <h3 style={columnHeaderStyle}>Yet to Start</h3>
                  <ul style={listStyle}>
                    {groupByStatus("yetToStart").map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>

                {/* In Progress Column 
                <div style={columnStyle}>
                  <h3 style={columnHeaderStyle}>In Progress</h3>
                  <ul style={listStyle}>
                    {groupByStatus("inProgress").map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>

                {/* Migrated Column 
                <div style={columnStyle}>
                  <h3 style={columnHeaderStyle}>Migrated</h3>
                  <ul style={listStyle}>
                    {groupByStatus("migrated").map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div> */}
                {/* Yet to Start Column */}
                <div style={columnStyle}>
                  <h3 style={columnHeaderStyle}>Yet to Start</h3>
                  {groupByStatus("yetToStart").map((item) => (
                    <div key={item} style={{ margin: "5px 0", fontSize: "14px" }}>
                      {item}
                    </div>
                  ))}
                </div>

                {/* In Progress Column */}
                <div style={columnStyle}>
                  <h3 style={columnHeaderStyle}>In Progress</h3>
                  {groupByStatus("inProgress").map((item) => (
                    <div key={item} style={{ margin: "5px 0", fontSize: "14px" }}>
                      {item}
                    </div>
                  ))}
                </div>

                {/* Migrated Column */}
                <div style={columnStyle}>
                  <h3 style={columnHeaderStyle}>Migrated</h3>
                  {groupByStatus("migrated").map((item) => (
                    <div key={item} style={{ margin: "5px 0", fontSize: "14px" }}>
                      {item}
                    </div>
                  ))}
                </div>

                 
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </MainTheme>

  );
};

export default Migration;